import { render, staticRenderFns } from "./SketchRuler.vue?vue&type=template&id=47fe6120&scoped=true"
import script from "./SketchRuler.vue?vue&type=script&lang=js"
export * from "./SketchRuler.vue?vue&type=script&lang=js"
import style0 from "./SketchRuler.vue?vue&type=style&index=0&id=47fe6120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe6120",
  null
  
)

export default component.exports